import { Button, Typography } from "@material-ui/core";
import '../../styles/Globales.scss';


import React, { Component } from 'react'

const SOLICITUD = 1;

export default class ButtonPdfComponent extends Component {

    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.tipoDoc);
        }
    }

    getDetalle=(tipoDoc)=>{
        let result = <Typography className="textoContrasena"> </Typography>;
        if(tipoDoc === SOLICITUD){
            result = (
              <Typography className="textoContrasena">
                  <strong>La contraseña</strong> para abrir el documento PDF es <strong>tu rut sin puntos ni digito verificador.</strong>
              </Typography>
            );
        }
        return result;
    }

    render() {
        return (
            <div className="contenedorBTNpdfPopup">
                <Button onClick={this.onClick} className="btnPdfDescarga" color="primary">
                    <div className="btnContainerPdf">
                        <img className="pdf" src={require('../../images/pdf.svg')} alt="pfd" />
                        <Typography> {this.props.tituloDocumento}</Typography>
                    </div>
                </Button>
                {this.getDetalle(this.props.tipoDoc)}
            </div>
        );
    }
}
